<template>
  <BContainer>
    <BRow align-v="center">
      <BCol lg="6" class="pr-lg-5">
        <cld-image
          public-id="v1557870558/state_of_visual_media/cloudinary-slide9.svg"
          alt="A globe with a laptop, a mobile phone, and data charts encircling it"
          fluid
          />
        <h2 class="my-4">Beware the growing long&nbsp;tail</h2>
        <p>While it may be tempting to deliver visual stories that work primarily for the most popular formats, browsers and devices, global brands should not disregard the importance of regional trends when it comes to the long tail.</p>
      </BCol>
      <BCol lg="6" class="pl-lg-5">
        <div class="wrap d-flex my-auto">
          <ChartDonut :num="numbers['old-chrome']" class="chart-donut special-size" />
          <p class="my-auto">are running a version of Chrome &gt;1 year old</p>
        </div>
        <v-popover popover-class="pp-50" placement="right">
          <LearnMore class="mt-5" />
          <template slot="popover">
            <div class="popover-title" style="margin: 0;">
              <cld-image
                class="tooltip-finger-icon"
                public-id="v1557870041/state_of_visual_media/cloudinary-finger.svg"
                alt="Icon of a hand with the index finger pointing up, representing a tool tip"
              />
              <strong>Long Tail Anecdotes</strong>
            </div>
            <b-row class="ml-4 mt-4">
              <b-col>
                <p><strong>7,000</strong> images per day from Lotus Notes users when they read an email campaign</p>
              </b-col>
              <b-col> <strong>15,000</strong> images per day on weekends from Nintendo DS devices </b-col>
            </b-row>
            <b-row class="ml-4 mt-4">
              <b-col>
                <ChartDonut :dark="true" :num="numbers['nokia-symbian']" class="chart-donut" />
                <p>
                  <strong>{{ numbers["nokia-symbian"] }}%</strong> of Nokia/Symbian traffic originates in India
                </p>
              </b-col>
              <b-col>
                <ChartDonut :dark="true" :num="numbers['roku-tv']" class="chart-donut" />
                <p>
                  <strong>{{ numbers["roku-tv"] }}%</strong> of Roku TV web browsing occurs between 6PM and midnight
                </p>
              </b-col>
              <b-col>
                <ChartDonut :dark="true" :num="numbers['blackberry']" class="chart-donut" />
                <p>
                  <strong>{{ numbers["blackberry"] }}%</strong> of legacy BlackBerry web browser traffic comes from the US, Canada, the UK and Germany
                </p>
              </b-col>
            </b-row>
          </template>
        </v-popover>
        <p class="mt-5">When technical decisions allow for diversity and regionality, global brands will be able to develop stronger relationships with significant audiences and client types. As consumers continue to see entertainment channels such as Nintendo and Roku TV as communication devices, brands have a big opportunity to make connections that are simply missed opportunities otherwise.</p>
      </BCol>
    </BRow>
    <footer class="w-50">
      <p class="small">Source: Nielsen Global Brand-Origin Study</p>
    </footer>
  </BContainer>
</template>

<script>
import LearnMore from "../LearnMore.vue";
import ChartDonut from "../donut-filled.vue";

export default {
  components: {
    LearnMore,
    ChartDonut
  },
  props: {
    numbers: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
  // computed: { }
};
</script>

<style lang="scss" scoped>
.special-size {
  $size: 120px;
  width: $size;
  height: $size;
  margin: 0;
  margin-right: 1em;
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    &:before {
      $dim: 12px;
      height: $dim;
      width: $dim;
      display: inline-block;
      content: "";
    }
  }
  &.access {
    li {
      &:nth-of-type(1):before {
        background: $blue;
      }
      &:nth-of-type(2):before {
        background: $gold;
      }
      &:nth-of-type(3):before {
        background: #ccc;
      }
    }
  }
  &.industry {
    li {
      &:nth-of-type(1):before {
        background: $blue;
      }
      &:nth-of-type(2):before {
        background: #a6a8ab;
      }
      &:nth-of-type(3):before {
        background: #bbbdbf;
      }
      &:nth-of-type(4):before {
        background: #d0d2d3;
      }
      &:nth-of-type(5):before {
        background: #e6e7e8;
      }
    }
  }
}
</style>
